
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { QuestionType } from "@/types/test";

export type QuestionBankItem = {
  id: string;
  question_type: QuestionType;
  content: any;
  time_limit: number | null;
  marks: number;
  category: string;
  skill_tags: string[];
  difficulty: string;
  verified: boolean;
  created_at: string;
};

export const useQuestionBank = (filters?: {
  category?: string;
  difficulty?: string;
  question_type?: QuestionType | 'all';
  skill_tags?: string[];
  searchQuery?: string;
}) => {
  return useQuery({
    queryKey: ['question-bank', filters],
    queryFn: async () => {
      let query = supabase
        .from('question_bank')
        .select('*')
        .order('created_at', { ascending: false });
      
      if (filters?.category && filters.category !== 'all') {
        query = query.eq('category', filters.category);
      }
      
      if (filters?.difficulty && filters.difficulty !== 'all') {
        query = query.eq('difficulty', filters.difficulty);
      }
      
      if (filters?.question_type && filters.question_type !== 'all') {
        query = query.eq('question_type', filters.question_type);
      }
      
      if (filters?.skill_tags && filters.skill_tags.length > 0) {
        query = query.contains('skill_tags', filters.skill_tags);
      }
      
      if (filters?.searchQuery) {
        // Search within the content->question field
        query = query.textSearch('content->>question', filters.searchQuery);
      }
      
      const { data, error } = await query;
      
      if (error) {
        console.error("Error fetching question bank:", error);
        throw new Error(`Failed to fetch question bank: ${error.message}`);
      }
      
      return data as QuestionBankItem[];
    },
  });
};
